import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';

export interface BannerCardCSSStyle extends UIComponentCSSStyle
{
    getBannerImageCSSStyle():object;
    getMobileBannerImageWrapperCSSStyle(): object;
}

export class BannerCardCSSStyleImpl extends UIComponentCSSStyleImpl implements BannerCardCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'100%',
            height:'250px',
            // opacity:'0.25',
            position:'relative',
            borderRadius:'0px',
            // background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
            // background: 'linear-gradient(225deg, #0030B7 0%, #4269D4 51.26%, #000000 100%)',
        };
    }

    getMobileBannerImageWrapperCSSStyle():object
    {
        return{
            width:'100%',
            height:'185px',
            // opacity:'0.25',
            position:'relative',
            borderRadius:'0px',
            // background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
            // background: 'linear-gradient(225deg, #0030B7 0%, #4269D4 51.26%, #000000 100%)',
        };
    }
       
    getBannerImageCSSStyle():object
    {
        return{
            width:'100%',
            height:'100%',
            position:'relative',display:'flex',
            borderRadius:'0px',
            // background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercard/bannercardcss.tsx